export const HAS_CICD = 'HAS_CICD';

export const checkForCiCd = (data) => {
    return {
        type: HAS_CICD,
        hasCiCd: data
    }
};